import { useExperiments } from '@modules/App/providers/ExperimentsProvider';
export const useDashboardExperiments = () => {
    const activeExperiments = useExperiments();
    const isVariant1 = activeExperiments.includes('dashboard-challenge-experiment-VARIANT_1');
    const isVariant2 = activeExperiments.includes('dashboard-challenge-experiment-VARIANT_2');
    const isVariant3 = activeExperiments.includes('dashboard-challenge-experiment-VARIANT_3');
    const isControl = activeExperiments.includes('dashboard-challenge-experiment-CONTROL');
    return {
        disableCreatorChallenge: isVariant1 || activeExperiments.length === 0,
        disableOnboardingMarketingCampaign: isVariant3,
        isVariant1,
        isVariant2,
        isVariant3,
        isControl,
    };
};
